import { ActivityIndicator } from 'react-native'
import styled from 'styled-components/native'
import { PrimaryButton } from 'APP/Components/Buttons'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'

export const Container = styled.View<{ paddingBottom: number }>`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
  padding-bottom: ${({ paddingBottom }) => paddingBottom}px;
`

export const LoadingIndicator = styled(ActivityIndicator)`
  flex: 1;
  justify-content: center;
  align-content: center;
  min-height: 100%;
`

export const RefreshButton = styled(DialogueTouchableOpacity)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
`

export const HeaderImage = styled.Image`
  height: 238px;
  width: 100%;
`

export const ContentContainer = styled.View`
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.8}px;
`

export const Title = styled(Typography)`
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
`

export const SubheaderContainer = styled.View`
  flex-direction: row;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
`

export const Subheader = styled(Typography)`
  padding-left: 5px;
`

export const AddHabitCta = styled(PrimaryButton)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  margin-horizontal: 0px;
`

export const BodyContainer = styled.View`
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

export const ExpertCard = styled.View`
  ${({ theme }) => theme.shadows.normal};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
  border-radius: 10px;
`

export const ExpertCaptionContainer = styled.View`
  flex-direction: row;
  align-items: center;
`

export const ExpertCaptionText = styled(Typography)`
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const ExpertContentContainer = styled.View`
  flex-direction: row;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ExpertTitle = styled(Typography)`
  font-family: 'PoynterOSDisp-Semibold';
`

export const ExpertSubtitle = styled(Typography)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.25}px;
`

export const ExpertAvatar = styled.Image`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
`

export const ExpertDetailsContainer = styled.View`
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
`
